<script>
export default {
  name: "UpsellRealRecipes",
  props: {
    isUpgrade: {
      type: Boolean,
      default: false,
    },
    hasSubscription: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    nextAction() {
      return "RealRecipes";
    },
  },
  mounted() {
    console.log(
      "isUpgrade? " +
        this.isUpgrade +
        " hasSubscription? " +
        this.hasSubscription
    );
  },
  methods: {
    doNextAction() {
      window.location = "/realrecipes";
    },
    noThankYou() {
      let params = {
        isUpgrade: this.isUpgrade,
        hasSubscription: this.hasSubscription,
      };
      this.$router.push({
        name: "ThankYou",
        params: params,
      });
    },
  },
};
</script>
<template>
  <div id="upsell-card">
    <p style="color: #e00b11; font-weight: 700; font-size: 38px">
      Early Bird for Real Recipes
    </p>
    <p
      style="
        padding: 0rem 3rem;
        letter-spacing: 0.05rem;
        font-weight: 500;
        color: #293847;
        font-size: 22px;
      "
    >
      <span style="color: #68ac55; font-weight: 900">IMPORTANT:</span> You are
      reading this message because this is an UNIQUE opportunity that will not
      be available for this price any more.
    </p>
    <!-- Show this button twice: once after the red title and once again after the texts -->
    <b-button
      class="ds-action-button ds-action-button-main"
      @click="doNextAction()"
      >BUY IT NOW</b-button
    >

    <p
      style="
        padding: 1rem 3rem;
        letter-spacing: 0.05rem;
        font-weight: 500;
        color: #293847;
        font-size: 22px;
      "
    >
      In this course that will be launched in March 2022, Melani will explain
      in details case studies and their <b>REAL RECIPES!</b> You will learn why
      these recipes worked or didn't work, and you will understand the principles of proper blending. Don't miss the
      opportunity to co-create this course with Melani and get your questions
      explained.
    </p>
    <p
      style="
        padding: 1rem 3rem;
        letter-spacing: 0.05rem;
        font-weight: 500;
        color: #293847;
        font-size: 28px;
      "
    >
      The ultimate course that will give you the credibility you need by
      getting the secrets behind blending.
    </p>
    <p
      style="
        padding: 1rem 3rem;
        letter-spacing: 0.05rem;
        font-weight: 500;
        color: #293847;
        font-size: 22px;
      "
    >
      Secure your spot for this excellent price now. Today is the ONLY chance
      you will have to get it for this price. Plus, you've got a 30-day money-back guarantee and a payment plan.
    </p>
    <p
      style="
        padding: 0rem 3rem;
        letter-spacing: 0.05rem;
        font-weight: 500;
        color: #293847;
        font-size: 22px;
      "
    >
      The price now is
      <span style="color: #68ac55; font-weight: 900">ONLY € 747 (or $ 847) - 30% OFF</span>. Please,
      don't lose it again. This is your last chance at this price!
    </p>
    <b-button
      class="ds-action-button ds-action-button-main"
      @click="doNextAction()"
      >BUY IT NOW</b-button
    >
    <p style="margin-top: 3rem">
      <b-link @click="noThankYou()">No, thank you. I prefer to pay more later.</b-link>
    </p>
  </div>
</template>
<style lang="scss">
#upsell-card {
  background-color: #fffcf4;
  border: 1px solid #fce682;
  border-radius: 4px;
  max-width: 1000px;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 3rem;
}
</style>